import React from 'react'
import { useLocation } from 'react-router-dom'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import SchoolBusNavMenu from '../../components/createForm/SchoolBusNavMenu'
import AddSiteMain from '../../components/sites/AddSiteMain'
import Footer from '../../components/common/Footer'
export default function SiteAddPage() {
    const location = useLocation()
    const isSchoolApp =
        localStorage.getItem("selectedApp") === "schoolTrack" ||
        location.pathname.startsWith("/school-sites")
    const NavigationMenu = isSchoolApp ? SchoolBusNavMenu : NavMenu

    return (
        <>
            <TitleBar />
            <NavigationMenu />
            <AddSiteMain />
            <Footer/>
        </>
    )
}
